// Auto-generated skeleton for Notification

export const Notification: Api.Notification = {
  id: 0,
  type: '',
  notifiable_type: '',
  notifiable_id: 0,
  data: null,
  read_at: null,
  created_at: null,
};

